import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SessionStorageService {

  public get<T = any>( key: string ): T | null
  {
    const value = sessionStorage.getItem(key);
    try {
      return value ? JSON.parse(value) as T : null;
    } catch {
      return null;
    }
  }

  public set<T = any>(key: string, value: T): void {
    sessionStorage.setItem(key, JSON.stringify(value));
  }

  public delete(key: string): void {
    sessionStorage.removeItem(key);
  }

  public clear(): void {
    sessionStorage.clear();
  }

  public has(key: string): boolean {
    return sessionStorage.getItem(key) !== null;
  }

  public keys(): string[]
  {
    return Object.keys( sessionStorage );
  }

}
